import BaseRepository from '@/api/repositories/BaseRepository';

class TextTemplateRepository extends BaseRepository {
	get endpoint() {
		return 'api/text_templates';
	}

	renderTextTemplate(key, data) {
		return this.get(`render_text_template/${key}`, data);
	}
}

export default new TextTemplateRepository();
